import React, { useState } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import queryString from "query-string";
import { useHistory } from "react-router-dom";
import TabPanel from "../../../elements/tab/materialTabPanel";
import ProjectContainer from "./projects/ProjectContainer";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledTabsBody, StyledTabsHead } from "../../../styles/styledTabs";

const DEFAULT_TAB = "projects";

const SupportUserDetailsTabsContainer = ({ match }) => {
    const { t } = useTranslation("supportUserPage");
    const history = useHistory();
    let queryParams = queryString.parse(history.location.search);

    const urlForTabs = () => {
      if (!queryParams.currentTab) {
        return 0;
      }

      switch (queryParams.currentTab) {
        case "projects": {
          return 0;
        }
      }
    };

    const tabValue = urlForTabs();

    const handleChange = (event, newValue) => {
      if (queryParams.currentTab !== newValue) {
        history.push("?currentTab=" + newValue);
      }
    };

    return (
      <StyledContentWrapper height="auto">
        <StyledTabsHead
          className="tab-head"
          orientation="horizontal"
        >
          <Tabs
            value={queryParams?.currentTab ?? DEFAULT_TAB}
            indicatorColor="secondary"
            onChange={handleChange}
            orientation="horizontal"
            className="tab-head-buttons"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label={t("details.tabs.project")} value="projects" />
          </Tabs>
        </StyledTabsHead>
        <StyledTabsBody className="tab-body" style={{ overflow: "inherit" }}>
          <TabPanel
            value={tabValue}
            index={0}
          >
            <ProjectContainer match={match} />
          </TabPanel>
        </StyledTabsBody>
      </StyledContentWrapper>
    );
  }
;

export default SupportUserDetailsTabsContainer;